export enum AuthAktoEtats {
  Initialisation,
  NonAuthentifié,
  EnAuthentificationCiam,
  AuthentifiéCiam,
  EnImpersonnalisation,
  Impersonnalisé,
  EnChargementPortefeuille,
  PortefeuilleChargé,
  Authentifié,
}
